import axios from "axios";

export const getRandomJokes = async () => {
  try {
    let url = `${process.env.REACT_APP_RANDOM_JOKES_URL}`;
    const res = await axios.get(url);
    return res.data.joke;
  } catch (error) {
    return (
      <>
        "Patience is not an ability to wait, but the ability to keep a good
        attitude while waiting."
        <br />
        <br /> - Annoying Person
      </>
    );
  }
};
